// This import loads the firebase namespace along with all its type information.
import MetricCursor from './metric-cursor-model'

export async function load_metricCursors(): Promise<MetricCursor[]> {
  throw 'Not implemented'
}

export async function delete_metricCursor(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_metricCursor(): Promise<MetricCursor> {
  throw 'Not implemented'
}
